import { useEffect, useState, useCallback } from "react"
import { designerServiceInstance } from "../services";

export const useCurrentDpi = () => {
    const [_, setDummy] = useState<{}>({});

    const onDpiChanged = useCallback(() => {
        setDummy({});
    }, []);

    useEffect(() => {
        window.addEventListener("dpi-changed", onDpiChanged)

        return () => {
            window.removeEventListener("dpi-changed", onDpiChanged)
        }
    }, []);

    return designerServiceInstance.GetDpi();
}